import PrivateRoute from 'common/components/private-route/PrivateRoute';
import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import AlertType from 'common/types/AlertType';
import FetchStatus from 'common/types/FetchStatus';
import ViewImage from 'domain/components/image/ViewImage';
import constants from 'domain/constants';
import { idleTimeout, isDevelopment } from 'env';
import DevSandboxContainer from 'features/_old/dev-sandbox/DevSandboxContainer';
import { useIdleTimer } from 'react-idle-timer';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import * as routes from '../routes';
import { logOut } from './auth/AuthSlice';
import Layout from './Layout';
import usePageTracking from 'common/hooks/usePageTracking';
const MySwitch = Switch as any;
const MyRoute = Route as any;
const MyRedirect = Redirect as any;

function App() {
  usePageTracking();
  const { authenticated, name, cartCount } = useTypedSelector((state) => ({
    name: state.profile.data.firstName,
    authenticated:
      state.auth.fetchStatus === FetchStatus.loaded &&
      state.auth.access_token !== null,
    cartCount: state.cart.groupRefKeys.length,
  }));
  const dispatch = useThunkDispatch();
  const { push: pushHistory } = useHistory();

  const logout = (message: string, type: AlertType) => {
    dispatch(logOut());
    pushHistory('/', {
      message,
      type,
    });
  };

  useIdleTimer({
    timeout: 1000 * 60 * idleTimeout,
    onIdle: () => {
      // don't fire logout if we aren't authenticated to begin with
      if (authenticated) {
        logout('You have been signed out due to inactivity.', AlertType.info);
      }
    },
    crossTab: {
      emitOnAllTabs: true,
    }, // Log out of all tabs when they are all idle
  });

  return (
    <MySwitch>
      <MyRoute exact path='/image/:filenet' component={ViewImage} />
      <MyRoute path='/'>
        <Layout
          isAuthenticated={authenticated}
          onLogOut={() => logout('Successfully logged out.', AlertType.success)}
          data={{
            name,
            cartCount,
          }}
        >
          <MySwitch>
            <MyRoute path='/' component={routes.Splash} exact />
            {!authenticated && (
              <MyRoute path='/auth' component={routes.AuthRouter} />
            )}
            <MyRoute
              path={constants.STATIC_PAGE_ROUTE}
              component={routes.StaticContentContainer}
            />
            {isDevelopment && (
              <MyRoute path='/dev-sandbox' component={DevSandboxContainer} />
            )}
            <PrivateRoute
              path='/dashboard'
              component={routes.AccountDashboardContainer}
              exact
            />
            <PrivateRoute
              path='/application-group/:groupKey'
              component={routes.GroupDetailsContainer}
            />
            <PrivateRoute
              path='/registrations/:refKey'
              component={routes.RegistrationDetailsContainer}
            />
            <PrivateRoute path='/profile' component={routes.ProfileContainer} />
            <PrivateRoute
              path='/apply-for-registration'
              component={routes.ApplyForRegistrationContainer}
            />
            <PrivateRoute
              path='/cancel-registration'
              component={routes.CancelRegistrationContainer}
            />
            <PrivateRoute
              path='/renew-registration/:groupRefKey'
              component={routes.RenewRegistrationContainer}
            />
            <PrivateRoute
              path='/vacation-rental'
              component={routes.VacationRentalContainer}
            />
            <PrivateRoute path='/cart' component={routes.CartContainer} />
            <PrivateRoute path='/order' component={routes.OrderRouter} />
            <PrivateRoute
              path='/advertising-platform'
              component={routes.AdvertisingPlatform}
            />
            <MyRedirect to={'/dashboard'} />
          </MySwitch>
        </Layout>
      </MyRoute>
    </MySwitch>
  );
}

export default App;
